import { IoMdFootball } from "react-icons/io";
import { Link } from "react-router-dom";

const Footer1 = () => {
  return (
    <footer className=" px-4 mb-5 mt-5">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_0.5fr_1fr_1fr] gap-2">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <Link className="flex items-center gap-1" to="/" title="Anasayfa">
                <h1 className="text-2xl font-extrabold tracking-tight">
                  h
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    a
                  </span>
                  l
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    i
                  </span>
                  s
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    a
                  </span>
                  h
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    a
                  </span>
                  b
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    u
                  </span>
                  l
                </h1>
                <img src="/reduced-logo.webp" alt="" className="w-15" />
              </Link>
            </h3>
            <p className="text-gray-400">
              Halısaha tutkunları için en iyi halısahaları bulabileceğiniz ve
              kolayca kiralıyabileceğiniz platform.
            </p>
          </div>

          {/* Navigation Links */}
          <nav aria-label="Hızlı Linkler">
            <h4 className="text-lg font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              {[
                { name: "Anasayfa", link: "/" },
                { name: "Sahalar", link: "/sahalar" },
                { name: "Hakkımızda", link: "/hakkimizda" },
                { name: "İletişim", link: "/iletisim" },
              ].map(({ name, link }) => (
                <li key={name}>
                  <Link
                    to={link}
                    title={name}
                    className="text-gray-400 hover:text-[#6ca87e] transition-colors"
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal Links */}
          <nav aria-label="Yasal Bilgiler">
            <h4 className="text-lg font-semibold mb-4">Yasal Bilgiler</h4>
            <ul className="space-y-2">
              {[
                { name: "SSL Sertifikası", link: "/ssl-sertifikasi" },
                { name: "Teslimat ve İade Şartları", link: "/teslimat-iade" },
                { name: "Gizlilik Sözleşmesi", link: "/gizlilik-politikasi" },
                { name: "Mesafeli Satış Sözleşmesi", link: "/mesafeli-satis" },
              ].map(({ name, link }) => (
                <li key={name}>
                  <Link
                    to={link}
                    title={name}
                    className="text-gray-400 hover:text-[#6ca87e] transition-colors"
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Social Media & Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">
              Bizimle iletişim kurun
            </h4>
            <div className="flex space-x-4 mb-5">
              {/* Instagram */}
              <a
                href="https://instagram.com/halisahabul1"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#4d9041] hover:text-[#62a556]"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9zm9.25 1.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9z" />
                </svg>
              </a>
              {/* Facebook */}
              <a href="#" className="text-[#4d9041] hover:text-[#62a556]">
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.04c-5.5 0-10 4.5-10 10 0 4.41 3.59 8.06 8.25 8.91v-6.31h-2.5v-2.6h2.5V9.94c0-2.5 1.5-3.87 3.78-3.87 1.09 0 2.22.19 2.22.19v2.44h-1.25c-1.22 0-1.59.75-1.59 1.53v1.84h2.75l-.44 2.6h-2.31v6.31c4.66-.85 8.25-4.5 8.25-8.91 0-5.5-4.5-10-10-10z" />
                </svg>
              </a>
              {/* Twitter */}
              <a href="#" className="text-[#4d9041] hover:text-[#62a556]">
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                </svg>
              </a>
              {/* GitHub */}
              <a
                href="https://github.com/BatiEng"
                className="text-[#4d9041] hover:text-[#62a556]"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.387.6.113.82-.26.82-.577v-2.04c-3.338.724-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.082-.73.082-.73 1.205.086 1.84 1.236 1.84 1.236 1.07 1.832 2.807 1.303 3.492.996.107-.776.418-1.303.76-1.602-2.665-.3-5.466-1.334-5.466-5.933 0-1.31.465-2.38 1.235-3.22-.123-.303-.535-1.522.118-3.176 0 0 1.008-.322 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.552 3.295-1.23 3.295-1.23.655 1.654.243 2.873.12 3.176.77.84 1.233 1.91 1.233 3.22 0 4.61-2.803 5.63-5.475 5.922.43.37.813 1.096.813 2.21v3.293c0 .32.218.694.825.576C20.565 21.796 24 17.296 24 12c0-6.63-5.37-12-12-12z"
                  />
                </svg>
              </a>
              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/in/ali-batıkan-öcal"
                className="text-[#4d9041] hover:text-[#62a556]"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.067 0-1.139.92-2.063 2.063-2.063 1.14 0 2.064.924 2.064 2.063 0 1.141-.925 2.067-2.064 2.067zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
            <p className="text-gray-400">📧 Email: destek@halisahabul.com</p>
            <p className="text-gray-400">📞 GSM: +90 (538) 237 1255</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer1;
